import { FunctionalComponent, h } from '@stencil/core';

export interface ListProps {
  listClass?: string;
  marker?: string;
  items?: string[];
  alignment?: listAlignment;
  fadeIn?: ListFadeDirection;
}

export const enum ListFadeDirection {
  NONE = '',
  LEFT = 'fadein-left',
  RIGHT = 'fadein-right',
  BOTTOM = 'fadein-bottom',
  TOP = 'fadein-top',
}

export const enum listAlignment {
  DEFAULT = '',
  VERTICAL = '-vertical',
}

export const List: FunctionalComponent<ListProps> = ({ listClass, marker, items, alignment, fadeIn }) => {
  return <rudy-list listClass={listClass} marker={marker} items={items} alignment={alignment} fadeIn={fadeIn} />;
};
